import { useEffect } from "react";
import { capitalize } from "../../components/Form/Form.js";

const addPrefijo = ({ name, area, showEstimate, kilo_unidad }, t) =>
    `${name}${area ? ` (${showEstimate}${t("general.number", { value: area })} ${kilo_unidad})` : ""}`;

const FarmMarker = ({ campo, childrenCommon }) => {
    const campoId = campo && campo.id.split("-")[1];
    useEffect(() => {
        const { bounds, linkIcon, closeInfoWindow, openInfoWindow, gmap } = childrenCommon;

        const LatLng = new window.google.maps.LatLng(campo.latitud, campo.longitud);
        bounds.extend(LatLng);

        const icon = {
            url: "/markers/x1-white.png",
            scaledSize: new window.google.maps.Size(24, 24),
            anchor: new window.google.maps.Point(24 / 2, 24)
        };

        const marker = new window.google.maps.Marker({
            draggable: false,
            position: LatLng,
            icon,
            map: gmap
        });

        marker.addListener("click", () => {
            // we do get "t" here to get the updated one
            const { t: innerT, lngs: lng, navigate } = childrenCommon;

            const cultivoLabel = campo.especie ?
                campo.especie.map((e) => e[lng[0]] || e[lng[1]]).join("-") + (campo.crops ? `-${capitalize(campo.crops)}` : "")
                :
                campo.crops ? capitalize(campo.crops) : "-";
            closeInfoWindow();
            openInfoWindow(
                gmap,
                `<div>${campo.name ? `<b>${addPrefijo(campo, innerT)}</b></br>` : ""}
        ${cultivoLabel ? `${cultivoLabel}</br>` : ""}
        <button type="button" class="btn btn-link m-0" id="clickListener" style="line-height:1.5em;">${linkIcon}</button>
        </div>`,
                marker.getPosition(),
                () => navigate(
                    { pathname: "/farms", search: `?farm=${campoId}` },
                    { state: {
                        /* expanded: typeof parent === "number" ? ["network", `campo-${parent}`, `campo-${nodo}`] : ["network", `nodo-${nodo}`], */
                        updateTree: true
                    } }
                )
            );
        }, { passive: true });

        return () => marker.setMap(null);

    }, [campo, childrenCommon]);

    return null;
};

export { FarmMarker };
